import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const downloadExcel = (data: any[], fileName: string) => {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  XLSX.writeFile(workbook, fileName);
};

export const downloadExcelDateFormat = (data: any[], fileName: string) => {
  const convertedData = data.map(row => {
    const newRow: any = { ...row };
    for (const key in newRow) {
      if (typeof newRow[key] === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(newRow[key])) {
        const parsed = new Date(newRow[key]);
        if (!isNaN(parsed.getTime())) newRow[key] = parsed;
      }
    }
    return newRow;
  });
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(convertedData);
  
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  XLSX.writeFile(workbook, fileName);
};

export const downloadExcelDateStringFormat = (data: any[], fileName: string) => {
  const convertedData = data.map(row => {
    const newRow: any = { ...row };
    for (const key in newRow) {
      if (
        typeof newRow[key] === 'string' &&
        /^\d{4}-\d{2}-\d{2}T/.test(newRow[key])
      ) {
        const parsed = new Date(newRow[key]);
        if (!isNaN(parsed.getTime())) newRow[key] = parsed;
      }
    }
    return newRow;
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(convertedData);

  Object.keys(worksheet).forEach(addr => {
    if (addr[0] === '!') return;

    const cell = worksheet[addr];
    if (typeof cell?.v === 'string' && /^0\d+/.test(cell.v)) {
      cell.t = 's'; 
    }
  });

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, fileName);
};

export const generateExcelWithMandatoryHeaders = async (
  headerData: Record<string, any>[], // array of single-key objects
  fileName: string,
  mandatoryFields: string[]
) => {
  if (!headerData || headerData.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  const headers = headerData.map(obj => Object.keys(obj)[0]);

  const headerRow = worksheet.addRow(headers);

  headerRow.eachCell((cell, colNumber) => {
    const header = headers[colNumber - 1]; 
    const isMandatory = mandatoryFields
      .map(m => m.trim().toLowerCase())
      .includes(header.trim().toLowerCase());
  
    cell.font = {
      bold:true,
      color: isMandatory ? { argb: 'FFFF0000' } : { argb: 'FF000000' } // Red for mandatory, black otherwise
    };
  
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  
    // Optional: light gray background for all headers (or remove this block entirely)
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCCCCC' },
    };
  });
  

  // Auto fit columns
  worksheet.columns.forEach((col, i) => {
    col.width = Math.max(15, headers[i]?.length || 15);
  });

  // Step 4: Export
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, fileName);
};



